import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';
import { CreditCard, Banknote } from 'lucide-react';
import type { PaymentMethod } from '@/services/payOnDelivery';

interface Props {
  value: PaymentMethod;
  onChange: (v: PaymentMethod) => void;
}

export function PaymentMethodSelector({ value, onChange }: Props) {
  const options = [
    { id: 'online' as const, title: 'Pay now online', desc: 'Card, transfer or USSD. Protected by escrow.', Icon: CreditCard },
    { id: 'pay_on_delivery' as const, title: 'Pay on delivery', desc: 'Pay cash or transfer when your order arrives. No transaction fee.', Icon: Banknote },
  ];
  return (
    <div className="space-y-2">
      <h4 className="font-medium text-sm">Payment method</h4>
      <RadioGroup value={value} onValueChange={(v) => onChange(v as PaymentMethod)} className="space-y-2">
        {options.map(({ id, title, desc, Icon }) => (
          <Label
            key={id}
            htmlFor={`pm-${id}`}
            className={`flex items-start gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${value === id ? 'border-primary bg-primary/5' : 'border-border'}`}
          >
            <RadioGroupItem value={id} id={`pm-${id}`} className="mt-0.5" />
            <Icon className="h-4 w-4 text-primary mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-sm font-medium">{title}</p>
              <p className="text-xs text-muted-foreground font-normal">{desc}</p>
            </div>
          </Label>
        ))}
      </RadioGroup>
    </div>
  );
}
